import store from '../store'
const methodsMixin = {
    data() {
        return {
          //rules前端验证
            // 分页参数
            pageparm: {
                currentPage: 1,
                pageSize: 10,
                total: 0,
                start: 0,
                length: 10
            },
            formInline: {
                start: 0,
                length: 10,

            },
        }
      },
      created() {
       
      },
    methods: {
        saveParams(path,pars){
          console.log(path)
       
            store.dispatch('saveListPagePars',{path,pars});
          },
          getParams(path){
          
            if(store.state.listPagePars.has(path)) {
              this.pars=store.state.listPagePars.get(path);
             
              this.formInline = this.pars
              this.pageparm.currentPage = this.pars.start+1
              this.pageparm.pageSize = this.pars.length
              this.pageparm.start =  this.pars.start
              this.pageparm.length = this.pars.length
             
            }
          },
          getEditParams(path){
          
            if(store.state.listPagePars.has(path)) {
              this.pars=store.state.listPagePars.get(path);        
              return this.pars
             
            }
          },
          // 分页插件事件
          callFather(parm) {
            this.pageparm.currentPage = parm.currentPage
            this.pageparm.pageSize = parm.pageSize
            this.pageparm.start = parm.currentPage - 1
            this.pageparm.length = parm.pageSize
            this.formInline.start = parm.currentPage - 1
            this.formInline.length = parm.pageSize
            this.getdata(this.formInline)
        },
          // 查询
          search() {     
            this.formInline.start = 0
            this.pageparm.currentPage = 1
            this.getdata(this.formInline)
        },
      
        clear() {
            this.formInline = {
                start: 0,
                length: 10,
               
            },
                this.getdata(this.formInline)
        },
    },
}
export default methodsMixin